import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const useBenefitMaxDrugStatusSchedule = (
  onSelect,
  hideModal,
  selectParams,
  selectMode,
  lookupType,
  selectModeParamData
) => {
  const [data, setData] = useState(
    []
  ); /* Benefit Max Drug Status Schedule Data */

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const [hideFlag, setHideFlag] = useState(false);
  const toast = useToast();
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  const {
    ADD_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
    EDIT_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
    DISPLAY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
    COPY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
    DRUG_STATUS_SCHEDULE,
    HIDE_UNHIDE_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
  } = ROUTE_PATHS;

  const stateVal = Array.isArray(location.state) ? location.state : []; // Ensure it's an array
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedSchedules = [],
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      bmdScheduleCode: "",
      hiddenRecordIndicator: "Active",
    },
  } = currentState;
  const initialParams = selectMode
    ? { ...selectModeParamData, hiddenRecordIndicator: "Active" }
    : initialParamsData;
  const [paramsData, setParamsData] = useState(initialParams);

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]?.bmdScheduleCode;
  const updatedParamsData = {
    ...paramsData,
    bmdScheduleCode: lastScheduleName,
  };
  console.log("paramsss", paramsData);
  const screen_title = "Benefit Max Drug Status Schedule";
  const screenNumber = selectMode ? "RCBMD005" : "RCBMD001";
  const bmdDescription = "bmdDescription";

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "bmdScheduleCode";
  const statusKey = "hiddenRecordIndicator";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "BMD Schedule Code",
      name: "bmdScheduleCode",
      label: "Schedule",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Hidden Record IndicatorValid Values",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 1,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];
  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Benefit Max Drug Status Schedule",
          button_handeler: () => {
            navigateToPage(ADD_BENEFIT_MAX_DRUG_STATUS_SCHEDULE, [
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = useMemo(() => {
    return selectMode
      ? [
          {
            label: "Select",
            icon: <span className="material-icons">add</span>,
            command: () => {
              const paramData = selectParams.reduce((acc, key) => {
                if (rowData.hasOwnProperty(key["target"])) {
                  acc[key["source"]] = rowData[key["target"]];
                }
                return acc;
              }, {});
              if (lookupType !== "external") {
                onSelect(paramData);
              } else {
                window.parent.postMessage(paramData);
              }
            },
          },
        ]
      : [
          {
            label: "Edit",
            icon: <span className="material-icons">edit</span>,
            command: () => {
              navigateToPage(EDIT_BENEFIT_MAX_DRUG_STATUS_SCHEDULE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                },
              ]);
            },
          },
          {
            label: "Copy",
            icon: <span className="material-icons">content_copy</span>,
            command: () => {
              navigateToPage(COPY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                },
              ]);
            },
          },
          {
            label: "Delete",
            icon: <span className="material-icons">delete</span>,
            command: () => {
              openConfirmationModal();
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              navigateToPage(DISPLAY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                },
              ]);
            },
          },
          {
            label: "Drug Status",
            icon: <span className="material-icons">medication</span>,
            command: () => {
              navigateToPage(DRUG_STATUS_SCHEDULE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  selectedDescriptions: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  currentIndex: 0,
                  previousScreen: ROUTE_PATHS.BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
                },
              ]);
            },
          },
          {
            label: rowData[statusKey] === "Hidden" ? "Unhide" : "Hide",
            icon: <span className="material-icons">visibility_off</span>,
            command: () => {
              openHideConfirmationModal();
            },
          },
        ];
  });

  /* Data table column info. */
  const columnDef = [
    {
      header: "Schedule",
      field: "bmdScheduleCode",
    },
    {
      header: "Description",
      field: "bmdDescription",
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
    },
  ];

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/bmdBenMaxDrugStsSch`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  const handleBack = () => {
    hideModal();
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, hideFlag]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const hideUnhideBenefitMaxDrugStatusSchedule = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        bmdScheduleCode: rowData[parmKey],
        screenNumber: screenNumber,
      };
      axios_helper_no_header(
        "PUT",
        "api/bmdBenMaxDrugStsSch/hideUnhide",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          setHideFlag(!hideFlag);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error hiding/unhiding the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };

  const deleteBenefitMaxDrugStatusSchedule = () => {
    if (selectedOption === "yes") {
      const params = { bmdScheduleCode: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/bmdBenMaxDrugStsSch", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/bmdBenMaxDrugStsSch/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    statusKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteBenefitMaxDrugStatusSchedule,
    setSelectedOption,
    hideUnhideBenefitMaxDrugStatusSchedule,
    isHideConfirmationModalOpen,
    closeHideConfirmationModal,
    setHideSelectedOption,
    hideModal,
  };
};

export default useBenefitMaxDrugStatusSchedule;
